// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a294032c","513":"8a8aea2b","787":"12791cf9"}[chunkId] + ".chunk.js";
};